import { reportCashReconciliationTypes } from './types';
import { newDate } from "helpers/dateTools";

const { GET_REPORT_CASH_RECONCILIATION, SET_REPORT_CASH_RECONCILIATION_FILTERS, RESTORE_INITIAL } = reportCashReconciliationTypes;

const initialState = {
  ReportCashReconciliation: [],
  date: newDate(),
  station: null,
};

export const reportCashReconciliationReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_REPORT_CASH_RECONCILIATION:
      return { ...state, ReportCashReconciliation: payload };
    case SET_REPORT_CASH_RECONCILIATION_FILTERS:
      return {
        ...state,
        [payload.key]: payload.value,
      };
    case RESTORE_INITIAL:
      return initialState;
    default:
      return state;
  }
};
